import { useIsAuthenticated } from 'apps/shared/scripts/hooks';

import { Step, StepProps } from '../../components';
import { FORM_FIELDS } from '../../components/OnboardingForm';

type Props = Omit<StepProps, 'heading' | 'subheading' | 'name' | 'percentage'>;

const OnboardingSenderContainer = (props: Props) => {
  const isAuthenticated = useIsAuthenticated();
  return (
    <Step
      {...props}
      heading="Who is the card from?"
      subheading="(Optional) This is the name that will appear in the card footer"
      name={FORM_FIELDS.SENDER_NAME.name}
      percentage={100}
      buttonLabel={isAuthenticated ? 'Create' : 'Continue'}
      isFinalStep
    />
  );
};

OnboardingSenderContainer.displayName = 'OnboardingSenderContainer';

export default OnboardingSenderContainer;
